



































































































































































































































































































import Vue from 'vue'
import {api} from "@/ts/constants"
import {Location, Media} from "@/ts/Media";
import {bytesToReadable, downloadFromUrl, filenameToDate, isTouchDevice} from "@/ts/utils";
import {format, parseISO} from 'date-fns'
import {LMap, LMarker, LTileLayer} from "vue2-leaflet";
import L from "leaflet";
import PhotoGallery from "@/components/PhotoGallery.vue";


export default Vue.extend({
    name: 'Photo',
    components: {PhotoGallery, LMap, LTileLayer, LMarker},
    props: {},
    data: () => ({
        isTouch: isTouchDevice(),
        videoPlaying: false,
        dateMenu: false,
        timeMenu: false,
        editingDate: new Date(),
        dateLoading: false,
        dateError: '',
        api,
        media: null as Media | null,
        isLoading: new Set(),
        loadInfo: 0,
        infoPaneSize: 400,
        reprocessLoading: false,
        deleteLoading: false,
        fixDateLoading: false,
        downloadLoading: false,
        leaflet: {
            zoom: 12,
            center: null as L.LatLng | null,
            url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            options: {
                zoomSnap: 0.5,
            },
            tileOptions: {
                id: 'mapbox/streets-v11',
                accessToken: '',
            },
            bounds: null as L.LatLngBounds | null,
            markers: [] as L.CircleMarker[],
        },
        gpsIcon: null as L.Icon | null,
        photoGallery: null as any,
        showPhotoMenu: false,
    }),
    async mounted() {
        this.photoGallery = this.$refs.photoGallery;
        this.leaflet.tileOptions.id = this.$vuetify.theme.dark ? 'mapbox/dark-v10' : 'mapbox/streets-v11';
        this.loadGpsIcon();

        this.leaflet.tileOptions.accessToken = this.$store.state.mapboxKey;
        this.media = this.queue.find(i => i.id === this.id) ?? null;
        await this.fullMediaLoad();

        this.loadGpsIcon().then();
    },
    methods: {
        async downloadItem() {
            this.downloadLoading = true;
            await downloadFromUrl(`${api}/photos/full/${this.id}`, this.media?.filename ?? 'image.jpg');
            this.showPhotoMenu = false;
            this.downloadLoading = false;
        },
        async loadGpsIcon() {
            if (this.media === null || this.media.location === null)
                return null;
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            const size = 42;
            const triangleSize = 8;
            const strokeWidth = 3;
            canvas.width = size;
            // + 10 for the triangle pointer below
            canvas.height = size + triangleSize;

            let image = new Image();
            image.src = `${api}/photo/tiny/${this.media.id}.webp`;
            image.crossOrigin = 'Anonymous'
            image.onload = () => {
                if (context === null) return;
                // const color = this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].primary as string;
                const color = 'black'
                context.fillStyle = color;
                context.strokeStyle = color;

                // Triangle pointer
                context.beginPath();
                context.moveTo(0, (size + triangleSize) / 2);
                context.lineTo(size, (size + triangleSize) / 2);
                context.lineTo(size / 2, size + triangleSize);
                context.fill();

                // Circular image with stroke
                context.save();
                context.beginPath();
                context.arc(size / 2, size / 2, size / 2 - strokeWidth / 2, 0, Math.PI * 2, false);
                context.lineWidth = strokeWidth;
                context.stroke();
                context.clip();
                this.drawImageProp(context, image, 0, 0, size, size);
                context.restore();

                // [...document.querySelectorAll('.test-canvas')].forEach(c => c.remove());
                // canvas.setAttribute('class', 'test-canvas');
                // document.body.appendChild(canvas);

                const url = canvas.toDataURL();
                this.gpsIcon = L.icon({
                    iconUrl: url,
                    iconSize: [size, size + 10],
                    iconAnchor: [size / 2, size]
                });
            }
        },
        /**
         * By Ken Fyrstenberg Nilsen
         *
         * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
         *
         * If image and context are only arguments rectangle will equal canvas
         */
        drawImageProp(ctx: CanvasRenderingContext2D, img: HTMLImageElement, x: number, y: number, w: number, h: number, offsetX: number | null = null, offsetY: number | null = null) {
            if (arguments.length === 2) {
                x = y = 0;
                w = ctx.canvas.width;
                h = ctx.canvas.height;
            }

            // default offset is center
            offsetX = typeof offsetX === "number" ? offsetX : 0.5;
            offsetY = typeof offsetY === "number" ? offsetY : 0.5;

            // keep bounds [0.0, 1.0]
            if (offsetX < 0) offsetX = 0;
            if (offsetY < 0) offsetY = 0;
            if (offsetX > 1) offsetX = 1;
            if (offsetY > 1) offsetY = 1;

            var iw = img.width,
                ih = img.height,
                r = Math.min(w / iw, h / ih),
                nw = iw * r,   // new prop. width
                nh = ih * r,   // new prop. height
                cx, cy, cw, ch, ar = 1;

            // decide which gap to fill
            if (nw < w) ar = w / nw;
            if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
            nw *= ar;
            nh *= ar;

            // calc source rectangle
            cw = iw / (nw / w);
            ch = ih / (nh / h);

            cx = (iw - cw) * offsetX;
            cy = (ih - ch) * offsetY;

            // make sure source rectangle is valid
            if (cx < 0) cx = 0;
            if (cy < 0) cy = 0;
            if (cw > iw) cw = iw;
            if (ch > ih) ch = ih;

            // fill image in dest. rectangle
            ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
        },
        async fixDateFromFile() {
            if (this.media === null) return;
            let filename = this.media.filename;
            if (filename === null) return;
            let newDate = filenameToDate(filename);
            if (newDate === null) {
                this.$store.dispatch('addSnack', {text: "Couldn't retrieve date from filename"}).then();
                return;
            }
            this.fixDateLoading = true;
            let accepted = await this.$store.dispatch('showPrompt', {
                title: `Is this date correct?`,
                subtitle: `
                    <p><b>Filename: </b>${filename}</p>
                    <div><b>New date: </b>${format(newDate, 'yyyy-MM-dd HH:mm:ss')}</div>
                `,
            });
            if (!accepted) {
                this.fixDateLoading = false;
                return;
            }
            await this.changeDate(newDate);
            this.showPhotoMenu = false;
            this.fixDateLoading = false;
        },
        async deleteItem() {
            if (this.media === null) return;
            this.deleteLoading = true;
            let accepted = await this.$store.dispatch('showPrompt', {
                title: `Are you sure you want to delete this ${this.media.type}`,
                subtitle: `This cannot be undone.`,
                confirmText: 'Delete',
            });
            if (!accepted) {
                this.showPhotoMenu = false;
                this.deleteLoading = false;
                return;
            }
            let success = await this.$store.dispatch('apiRequest', {
                url: `photos/deleteItem/${this.media.id}`
            });
            if (success) {
                this.$store.dispatch('addSnack', {text: 'Deleted ' + this.media.filename}).then();
                this.next();
                this.$store.commit('reloadPhotos', this.media);
            } else {
                this.$store.dispatch('addSnack', {text: 'Failed to delete ' + this.media.filename}).then();
            }
            this.showPhotoMenu = false;
            this.deleteLoading = false;
        },
        async changeDate(date: Date) {
            if (this.media === null) return;
            let success = await this.$store.dispatch('apiRequest', {
                url: `photos/changeDate/${this.media.id}`,
                body: {date: date.getTime()}
            });
            if (success === true) {
                this.dateError = '';
                this.media.createDate = date;

                this.$store.commit('reloadPhotos', this.media);
                return true;
            } else {
                return false;
            }
        },
        async saveEditedDate() {
            if (this.media === null) return;
            let isDateMenu = this.dateMenu;
            this.dateLoading = true;
            let success = await this.changeDate(this.editedDate);
            if (success) {
                if (isDateMenu) this.dateMenu = false;
                else this.timeMenu = false;
            } else {
                this.dateError = isDateMenu ? 'Failed to set date!' : 'Failed to set time!';
            }
            this.dateLoading = false;
            this.showPhotoMenu = false;
        },
        openMaps(location: Location | null) {
            if (location === null)
                return;
            window.open(`https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`)
        },
        async reprocess(media: Media) {
            this.reprocessLoading = true;
            let {id} = await this.$store.dispatch('apiRequest', {url: `photos/reprocess/${media.id}`});
            let path = this.$route.path.split('/').filter(p => p.length !== 0);
            path[path.length - 1] = id;
            await this.$router.replace(`/${path.join('/')}`);
            this.$store.commit('reloadPhotos', true);
            this.reprocessLoading = false;
            this.showPhotoMenu = false;
        },
        close() {
            let path = this.$route.path.split('/').filter(p => p.length !== 0);
            let newPath = '/' + path.slice(0, path.length - 2).join('/');
            this.$router.push(newPath);
        },
        previous() {
            this.photoGallery.swiper.slidePrev();
            return;
        },
        next() {
            this.photoGallery.swiper.slideNext();
            return;
        },
        async fullMediaLoad(idOverride: string | null = null) {
            let id = idOverride ?? this.media?.id ?? this.id;
            if (this.isLoading.has(id))
                return;
            this.isLoading.add(id);

            let media = await this.$store.dispatch('apiRequest', {url: `photos/${id}`}).then(Media.fromObject);
            if (idOverride !== null || this.media === null || id === this.media?.id) {
                this.media = media;
                this.loadInfo++;
            }
            this.isLoading.delete(id);
        },
    },
    computed: {
        coordinate(): L.LatLng | null {
            if (this.media === null || this.media.location === null)
                return null;
            return L.latLng(this.media.location.latitude, this.media.location.longitude)
        },
        classifications(): { labels: string, glossary: string }[] | null {
            let classification = this.media?.classifications ?? null;
            if (classification === null)
                return null;
            const capitalize = (s: string) => s.substr(0, 1).toUpperCase() + s.substr(1);
            return classification.map(c => ({
                firstLabel: c.levels[0].labels[0],
                labels: c.levels[0].labels.slice(0, 3).join(', '),
                glossary: capitalize(c.levels[0].glossary),
            }))
        },
        country(): string | null {
            return this.media?.location?.places?.find?.(p => p.type === 'country')?.name ?? null;
        },
        place(): string | null {
            return this.media?.location?.places?.find?.(p => p.type === 'place')?.name ?? null;
        },
        subPlace(): string | null {
            return [...this.admins, this.country].join(', ')
        },
        admins(): string[] {
            let location = this.media?.location ?? null;
            if (location === null)
                return [];
            return location.places.filter(p => p.type !== 'place' && p.type !== 'country').map(p => p.name);
        },
        exposureTime(): string | null {
            let exposureTime = this.media?.exif?.ExposureTime ?? null;
            if (exposureTime === null)
                return null;
            if (exposureTime < 1)
                return `1/${Math.round(1 / exposureTime)}`
            return exposureTime.toString();
        },
        readableBytes(): string {
            return bytesToReadable(this.media?.size ?? 0);
        },
        showInfo: {
            get(): boolean {
                return this.$store.state.showInfo;
            },
            set(v: boolean) {
                this.$store.commit('showInfo', v);
            }
        },
        editedDate(): Date {
            return new Date(`${this.createDate} ${this.createTime}`);
        },
        formattedCreateTime(): string {
            let date = this.media?.createDate ?? new Date();
            return format(date, 'H:mm:ss');
        },
        formattedCreateDate(): string {
            let date = this.media?.createDate ?? new Date();
            return format(date, 'EEEE, do MMMM yyyy');
        },
        createTime: {
            get(): string {
                let date = this.editingDate ?? new Date();
                return format(date, 'H:mm:ss')
            },
            set(v: string) {
                this.editingDate = new Date(`${this.createDate} ${v}`);
            }
        },
        createDate: {
            get(): string {
                let date = this.editingDate ?? new Date();
                return format(parseISO(date.toISOString()), 'yyyy-MM-dd');
            },
            set(v: string) {
                if (this.media === null) return;
                this.editingDate = new Date(`${v} ${this.createTime}`);
            }
        },
        megaPixels(): number {
            return Math.round((this.media?.width ?? 0) * (this.media?.height ?? 0) / 100000) / 10;
        },
        canSkipLeft(): boolean {
            return this.index > 0;
        },
        canSkipRight(): boolean {
            return this.index + 1 < this.queue.length;
        },
        index(): number {
            return this.queue.findIndex(i => i.id === this.id);
        },
        queue(): Media[] {
            return this.$store.state.viewerQueue;
        },
        id(): string {
            return this.$route.params.id;
        },
    },
    watch: {
        showInfo() {
            if (this.$vuetify.breakpoint.mobile)
                return;
            let animationFrame = -1;
            const resize = () => {
                animationFrame = requestAnimationFrame(resize);
                console.log("ResizeHandler")
                this.photoGallery.swiper.resize.resizeHandler();
            }
            resize();
            setTimeout(() => cancelAnimationFrame(animationFrame), 250);
        },
        'media.location'() {
            this.gpsIcon = null;
            this.loadGpsIcon();
        },
        media() {
            if (this.media !== null)
                this.editingDate = this.media?.createDate ?? new Date();
        },
        id() {
            this.videoPlaying = false;
            this.fullMediaLoad(this.id);
        },
    },
})
